import {
  InputGroup,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  AbsoluteCenter,
  Box,
  Divider,
  Text,
  Input,
} from '@chakra-ui/react';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import moment from 'moment';
import './calendar.scss';
import { UseFilterConfigs } from '../useFilterConfigs';

type FilterInputProps = {
  title: string;
  value: string;
  placeholder?: string;
  disabled?: boolean;
  isInvalid?: boolean;
} & Pick<UseFilterConfigs, 'changeValue'>;

export const FilterNumberInput = (props: FilterInputProps) => (
  <InputGroup size="sm" variant="outline" my="1">
    <NumberInput
      step={1}
      isInvalid={props.isInvalid}
      focusInputOnChange={true}
      inputMode="numeric"
      width="100%"
      value={props.value}
      onChange={(valueString) => props.changeValue(props.title, valueString)}
    >
      <NumberInputField
        placeholder={props.placeholder ?? 'Value'}
        rounded="2xl"
      />
      <NumberInputStepper>
        <NumberIncrementStepper children={<FaChevronUp size="10px" />} />
        <NumberDecrementStepper children={<FaChevronDown size="10px" />} />
      </NumberInputStepper>
    </NumberInput>
  </InputGroup>
);

export const BetweenAndDivider = () => (
  <Box position="relative" padding="1" my="2">
    <Divider />
    <AbsoluteCenter
      bg="Background"
      px="4"
      rounded="2xl"
      textTransform="uppercase"
    >
      <Text fontSize="11px">And</Text>
    </AbsoluteCenter>
  </Box>
);

export const FilterTextInput = (props: FilterInputProps) => (
  <Input
    my="1"
    rounded="2xl"
    isInvalid={props.isInvalid}
    size="sm"
    variant="filled"
    type="text"
    placeholder={props.placeholder ?? 'Value'}
    value={props.value}
    isDisabled={props.disabled}
    onChange={(e) => props.changeValue(props.title, e.target.value)}
  />
);

export const FilterDateInput = ({
  title,
  value,
  isInvalid,
  changeValue,
}: FilterInputProps) => {
  return (
    <Input
      my="1"
      placeholder="Select Date and Time"
      size="sm"
      isInvalid={isInvalid}
      type="date"
      rounded="2xl"
      value={value}
      onChange={(e) => changeValue(title, e.target.value)}
    />
  );
};

// import Calendar from 'react-calendar';
// const formatDate = (date: Date) => moment(date).format('YYYY-MM-DD'); // MM/DD/YYYY
// const datePickerInput = () => (
//   <InputGroup my="1" size="sm" variant="filled" width="290px">
//     <InputLeftAddon
//       as={MenuButton}
//       rounded="2xl"
//       children={<BsCalendarDate />}
//     />
//     <Input
//       fontSize="12px"
//       rounded="2xl"
//       value={value}
//       onChange={(e) => changeValue(title, e.target.value)}
//     />
//     <InputRightAddon
//       as={MenuButton}
//       cursor="pointer"
//       rounded="2xl"
//       children={<BiChevronDown />}
//     />
//   </InputGroup>
// );

// const datePickerMenu = (onClose: () => void) => (
//   <MenuList p="0" borderRadius="10px">
//     <Calendar
//       onChange={(date) => {
//         date && changeValue(title, formatDate(date as Date));
//         onClose();
//       }}
//       className="custom-calendar"
//       value={isValidDate(value) ? new Date(value) : new Date()}
//     />
//   </MenuList>
// );

// return (
//   <Menu placement="bottom-end">
//     {({ onClose }) => (
//       <>
//         {datePickerInput()}
//         {datePickerMenu(onClose)}
//       </>
//     )}
//   </Menu>
// );
